import { render, staticRenderFns } from "./NotableIndividualView.vue?vue&type=template&id=3baf8cea&scoped=true"
import script from "./NotableIndividualView.vue?vue&type=script&lang=js"
export * from "./NotableIndividualView.vue?vue&type=script&lang=js"
import style0 from "./NotableIndividualView.vue?vue&type=style&index=0&id=3baf8cea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3baf8cea",
  null
  
)

export default component.exports